import { ComponentWithAs, createIcon, IconProps } from '@chakra-ui/react'

export const FlagIcon: ComponentWithAs<'svg', IconProps> = createIcon({
    displayName: 'FlagIcon',
    viewBox: '0 0 10 12',
    path: <path d="M0 4L8 7.5V11.5H10V0.5H8L0 4Z" fill="currentColor" />
})
